import {campaignPlan} from './challenge';
import type { LevelDefinition, AlgorithmId, CampaignPhaseResult } from '@algoquest/schemas';
export interface AttemptPerformance { mistakes: number; hints: number; comparisons: number; swaps: number; shifts: number }
export function operationBudget(level: LevelDefinition): number {
  if(level.masteryConditions.targetOperationCount !== undefined) return level.masteryConditions.targetOperationCount;
  const n=level.dataset.values.length;
  switch(level.algorithm) {
    case 'linear-search': return n;
    case 'binary-search': return Math.ceil(Math.log2(n+1));
    case 'selection-sort': return n*(n-1)/2+n-1;
    default: return n*(n-1); // comparisons plus swaps/shifts in the worst case
  }
}
export function rateCampaignAttempt(level: LevelDefinition, performance: AttemptPerformance & {algorithm?:AlgorithmId;algorithmUsed?:AlgorithmId|null;phaseResults?:CampaignPhaseResult[]|null}, completed=true): number {
  if(!completed) return 0;
  const {mistakes,hints,comparisons,swaps,shifts}=performance;
  if(mistakes===0 && hints===0 && comparisons+swaps+shifts<=(performance.phaseResults?.length?campaignPlan(level,performance.algorithm??performance.algorithmUsed??level.algorithm).reduce((sum,p)=>sum+operationBudget(p),0):operationBudget(level))) return 3;
  if(mistakes<=2 && hints<=1) return 2;
  return 1;
}
/** Previously completed levels remain replayable, including pre-lock history. */
export function isCampaignLevelUnlocked(number: number, completed: ReadonlySet<number>): boolean {
  if(!Number.isInteger(number) || number<1 || number>100) return false;
  if(completed.has(number)) return true;
  for(let n=1;n<number;n++) if(!completed.has(n)) return false;
  return true;
}
export function mergeBestStars(...sources: ReadonlyMap<number,number>[]): Map<number,number> {
  const merged=new Map<number,number>();
  for(const source of sources) for(const [n,stars] of source) merged.set(n,Math.max(merged.get(n)??0,stars));
  return merged;
}
